import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const GetNotifications = createAsyncThunk(
  "Home/GetNotifications",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/notifications`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors.errors);
    }
  }
);
export const updateNotifications = createAsyncThunk(
  "Home/updateNotifications",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .put(
          `${process.env.REACT_APP_BACKEND_API}api/admin/notifications/${id}/mark-as-read`,
          { id: id },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonDT")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors.errors);
    }
  }
);

export const getSlider = createAsyncThunk(
  "Home/getSlider",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/sliders`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const addSlider = createAsyncThunk(
  "Home/addSlider",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/sliders`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateSlider = createAsyncThunk(
  "Home/updateSlider",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/sliders/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteSlider = createAsyncThunk(
  "Home/deleteSlider",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/sliders/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getBlogs = createAsyncThunk(
  "Home/getBlogs",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/blogs`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// export const addBlogs = createAsyncThunk(
//   "Home/addBlogs",
//   async (data, thunkAPI) => {
//     const { rejectWithValue } = thunkAPI;
//     try {
//       const result = await axios.post(
//         `${process.env.REACT_APP_BACKEND_API}api/admin/blogs`,
//         data,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             Accept: "application/json",
//             Authorization: `Bearer ${Cookies.get("QanonDT")}`,
//           },
//         }
//       );
//       return result.data;
//     } catch (err) {
//       return rejectWithValue(err.response.data.errors);
//     }
//   }
// );
export const updateBlogs = createAsyncThunk(
  "Home/updateBlogs",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/blogs/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteBlogs = createAsyncThunk(
  "Home/deleteBlogs",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/blogs/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const deleteBlogsReactions = createAsyncThunk(
  "Home/deleteBlogsReactions",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/blog_reactions/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getConsultationTypes = createAsyncThunk(
  "Home/getConsultationTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/consultation_types`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const addConsultationTypes = createAsyncThunk(
  "Home/addConsultationTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/consultation_types`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateConsultationTypes = createAsyncThunk(
  "Home/updateConsultationTypes",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/consultation_types/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteConsultationTypes = createAsyncThunk(
  "Home/deleteConsultationTypes",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/consultation_types/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getEconomicConsultation = createAsyncThunk(
  "Home/getEconomicConsultation",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/economic_consultations`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateEconomicConsultation = createAsyncThunk(
  "Home/updateEconomicConsultation",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/economic_consultations/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteEconomicConsultation = createAsyncThunk(
  "Home/deleteEconomicConsultation",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/economic_consultations/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

// private_consultations
export const getPrivateConsultation = createAsyncThunk(
  "Home/getPrivateConsultation",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/private_consultations`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updatePrivateConsultation = createAsyncThunk(
  "Home/updatePrivateConsultation",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/private_consultations/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deletePrivateConsultation = createAsyncThunk(
  "Home/deletePrivateConsultation",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/private_consultations/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getAppointmentConsultations = createAsyncThunk(
  "Home/getAppointmentConsultations",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/appointment_consultations`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateAppointmentConsultations = createAsyncThunk(
  "Home/updateAppointmentConsultations",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/appointment_consultations/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteAppointmentConsultations = createAsyncThunk(
  "Home/deleteAppointmentConsultations",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/appointment_consultations/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonDT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

const HomeSlice = createSlice({
  name: "Home",
  initialState: {
    isHomeLoading: false,

    notificationArr: null,
    SliderArray: null,
    BlogsArray: null,
    ConsultationTypesArray: null,
    EconomicConsultationArray: null,
    PrivateConsultationArray: null,
    AppointmentConsultationsArray: null,
  },

  extraReducers: (builder) => {
    builder
      .addCase(GetNotifications.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(GetNotifications.fulfilled, (state, action) => {
        state.isHomeLoading = false;
        state.notificationArr = action.payload.data;
      })
      .addCase(GetNotifications.rejected, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(updateNotifications.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(updateNotifications.fulfilled, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(updateNotifications.rejected, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(getBlogs.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(getBlogs.fulfilled, (state, action) => {
        state.isHomeLoading = false;
        state.BlogsArray = action.payload.data;
      })
      .addCase(getBlogs.rejected, (state, action) => {
        state.isHomeLoading = false;
      })

      .addCase(updateBlogs.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(updateBlogs.fulfilled, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(updateBlogs.rejected, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(deleteBlogs.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(deleteBlogs.fulfilled, (state, action) => {
        state.isHomeLoading = false;
        state.BlogsArray = state.BlogsArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteBlogs.rejected, (state, action) => {
        state.isHomeLoading = false;
      })
      // deleteBlogsReactions
      .addCase(deleteBlogsReactions.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(deleteBlogsReactions.fulfilled, (state, action) => {
        state.isHomeLoading = false;
        // state.BlogsArray = state.BlogsArray.filter(
        //   (ele) => ele.id !== action.meta.arg
        // );
      })
      .addCase(deleteBlogsReactions.rejected, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(getSlider.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(getSlider.fulfilled, (state, action) => {
        state.isHomeLoading = false;
        state.SliderArray = action.payload.data;
      })
      .addCase(getSlider.rejected, (state, action) => {
        state.isHomeLoading = false;
      })

      .addCase(addSlider.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(addSlider.fulfilled, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(addSlider.rejected, (state, action) => {
        state.isHomeLoading = false;
      })

      .addCase(updateSlider.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(updateSlider.fulfilled, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(updateSlider.rejected, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(deleteSlider.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(deleteSlider.fulfilled, (state, action) => {
        state.isHomeLoading = false;
        state.SliderArray = state.SliderArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteSlider.rejected, (state, action) => {
        state.isHomeLoading = false;
      })

      .addCase(getConsultationTypes.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(getConsultationTypes.fulfilled, (state, action) => {
        state.isHomeLoading = false;
        state.ConsultationTypesArray = action.payload.data;
      })
      .addCase(getConsultationTypes.rejected, (state, action) => {
        state.isHomeLoading = false;
      })

      .addCase(addConsultationTypes.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(addConsultationTypes.fulfilled, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(addConsultationTypes.rejected, (state, action) => {
        state.isHomeLoading = false;
      })

      .addCase(updateConsultationTypes.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(updateConsultationTypes.fulfilled, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(updateConsultationTypes.rejected, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(deleteConsultationTypes.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(deleteConsultationTypes.fulfilled, (state, action) => {
        state.isHomeLoading = false;
        state.ConsultationTypesArray = state.ConsultationTypesArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteConsultationTypes.rejected, (state, action) => {
        state.isHomeLoading = false;
      })

      .addCase(getEconomicConsultation.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(getEconomicConsultation.fulfilled, (state, action) => {
        state.isHomeLoading = false;
        state.EconomicConsultationArray = action.payload.data;
      })
      .addCase(getEconomicConsultation.rejected, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(updateEconomicConsultation.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(updateEconomicConsultation.fulfilled, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(updateEconomicConsultation.rejected, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(deleteEconomicConsultation.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(deleteEconomicConsultation.fulfilled, (state, action) => {
        state.isHomeLoading = false;
        state.EconomicConsultationArray = state.EconomicConsultationArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteEconomicConsultation.rejected, (state, action) => {
        state.isHomeLoading = false;
      })

      .addCase(getPrivateConsultation.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(getPrivateConsultation.fulfilled, (state, action) => {
        state.isHomeLoading = false;
        state.PrivateConsultationArray = action.payload.data;
      })
      .addCase(getPrivateConsultation.rejected, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(updatePrivateConsultation.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(updatePrivateConsultation.fulfilled, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(updatePrivateConsultation.rejected, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(deletePrivateConsultation.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(deletePrivateConsultation.fulfilled, (state, action) => {
        state.isHomeLoading = false;
        state.PrivateConsultationArray = state.PrivateConsultationArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deletePrivateConsultation.rejected, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(getAppointmentConsultations.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(getAppointmentConsultations.fulfilled, (state, action) => {
        state.isHomeLoading = false;
        state.AppointmentConsultationsArray = action.payload.data;
      })
      .addCase(getAppointmentConsultations.rejected, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(updateAppointmentConsultations.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(updateAppointmentConsultations.fulfilled, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(updateAppointmentConsultations.rejected, (state, action) => {
        state.isHomeLoading = false;
      })
      .addCase(deleteAppointmentConsultations.pending, (state) => {
        state.isHomeLoading = true;
      })
      .addCase(deleteAppointmentConsultations.fulfilled, (state, action) => {
        state.isHomeLoading = false;
        state.AppointmentConsultationsArray = state.AppointmentConsultationsArray.filter(
          (ele) => ele.id !== action.meta.arg
        );
      })
      .addCase(deleteAppointmentConsultations.rejected, (state, action) => {
        state.isHomeLoading = false;
      });
  },
});

export default HomeSlice.reducer;
